import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { environment } from '../../../../environments/environment';

/**
 * Main Layout Component - Admin Portal
 * Wraps the entire admin application with sidebar and topbar navigation
 * Based on web portal layout but for internal staff operations
 */
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, SidebarComponent, TopbarComponent],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  sidebarCollapsed: boolean = true; // Start collapsed on mobile

  // Footer meta (moved out of the sidebar)
  appVersion = environment.version;

  /**
   * Toggle sidebar collapsed state
   */
  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  /**
   * Close sidebar when clicking on overlay (mobile only)
   */
  @HostListener('click', ['$event'])
  onLayoutClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // Check if click is on the overlay (app-layout but not sidebar or its children)
    if (target.classList.contains('app-layout') && !this.sidebarCollapsed) {
      this.sidebarCollapsed = true;
    }
  }
}
